module.exports = __webpack_public_path__ + "enr-static/img/icon_info_g10.624c148d.svg";